<div *ngIf="design == 'row_a'" class="frame-body">
  <div>
    <br />
    <span style="font-size: 32px; font-weight: 400"
      >{{ inputDetailInformation.variety_name }}
    </span>
    <br />
    <span
      style="
        font-size: 24px;
        font-weight: 300;
        font-style: italic;
        margin-top: -8px;
      "
      *ngIf="inputDetailInformation.synonyms"
    >
      {{ inputDetailInformation.synonyms }}
    </span>
  </div>
</div>

<div *ngIf="design == 'row_a'" [style.background-color]="background_color">
  <div
    class="frame-body"
    fxLayout="row wrap"
    fxLayoutAlign="space-around center"
  >
    <div
      fxFlex="50"
      fxFlex.sm="100"
      fxFlex.xs="100"
      style="margin-bottom: 2em; padding-right: 2em"
    >
      <div
        style="color: #8b2f00; padding: 1.5em 0em"
        *ngIf="inputDetailInformation.species"
      >
        <span style="font-family: Raleway; font-weight: 700; font-size: 1.8em"
          >Especie:</span
        >
        <span
          style="
            font-family: Raleway;
            font-weight: 200;
            font-size: 1.8em;
            font-style: italic;
            color: #777777;
          "
        >
          {{ inputDetailInformation.species }}</span
        >
      </div>
      <mat-divider
        style="border-top-width: 0.25em"
        *ngIf="inputDetailInformation.meaning"
      ></mat-divider>
      <div
        style="color: #8b2f00; padding: 1.5em 0em"
        *ngIf="inputDetailInformation.meaning"
      >
        <span
          style="font-family: Raleway; font-weight: 500; font-size: 1.8em"
          >{{ inputDetailInformation.meaning }}</span
        >
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <span style="font-size: 18px">Observador principal</span>
          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              <mat-icon style="font-size: 50px; width: 50px; height: 50px"
                >account_circle</mat-icon
              >
            </div>
            <div style="margin: 0px 12px">
              <span style="font-weight: bold">{{
                inputDetailInformation.username
              }}</span>
              <br />

              <!-- 
              <img
                style="
                  height: 14px;
                  width: 14px;
                  object-fit: cover;
                  color: #bbb;
                  margin-bottom: -2px;
                "
                src="https://wikipapa.org/images/favpng_binoculars.png"
              />
              {{ inputDetailInformation.public_observation_count_usr }}
 -->

              <span
                (click)="
                  fnGoToView(
                    'observaciones',
                    inputDetailInformation.user_id,
                    inputDetailInformation.username
                  )
                "
                style="color: #1e88e5; cursor: pointer"
              >
                <img
                  style="
                    height: 14px;
                    width: 14px;
                    object-fit: cover;
                    color: #bbb;
                    margin-bottom: -2px;
                  "
                  src="https://wikipapa.org/images/favpng_binoculars.png"
                />
                {{ inputDetailInformation.public_observation_count_usr }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
          <span style="font-size: 18px">Ultima observación</span>

          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              <mat-icon style="font-size: 50px; width: 50px; height: 50px"
                >image</mat-icon
              >
            </div>
            <div style="margin: 0px 12px">
              <span style="font-weight: bold">{{
                inputDetailInformation.observation_date.substring(10, 0)
              }}</span>
              <br />
              <!-- <a href="#"> Ver observación</a> -->

              <span
                style="color: #1e88e5; cursor: pointer"
                (click)="fnGoObs(inputDetailInformation.variety_observation_id)"
              >
                Ver observación
              </span>
            </div>
          </div>
        </div>
        <br /><br />
        <div>
          <span style="font-size: 18px">Total de observaciones</span>

          <div fxLayout="row" fxLayoutAlign="start center">
            <div>
              <img
                style="
                  height: 50px;
                  width: 50px;
                  object-fit: cover;
                  color: #bbb;
                  margin-bottom: -2px;
                "
                src="https://wikipapa.org/images/favpng_binoculars.png"
              />
            </div>
            <div style="margin: 0px 12px">
              <span style="font-weight: bold">{{
                inputDetailInformation.public_observation_count
              }}</span>
              <br />
              <!-- <a href="#"> Ver todas</a> -->

              <span
                style="color: #1e88e5; cursor: pointer"
                (click)="fnGoObsVar(inputDetailInformation.variety_name)"
              >
                Ver todas
              </span>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="myAngularxQrCode">
        <qrcode
          [qrdata]="myAngularxQrCode"
          [width]="150"
          [errorCorrectionLevel]="'M'"
        ></qrcode>
        <button mat-stroked-button color="primary" (click)="fnGoGenotype()">
          <mat-icon>open_in_new</mat-icon> Abrir en una nueva ventana
        </button>
      </div>
    </div>

    <div
      fxFlex="50"
      fxFlex.sm="100"
      fxFlex.xs="100"
      style="margin: 2em 0em; padding-left: 2em"
    >
      <app-slider-image
        [images]="images"
        [indexImg]="indexImg"
        [heightImg]="'270px'"
      ></app-slider-image>
    </div>
  </div>
</div>

<!-- =================================================== -->

<div *ngIf="design == 'row_b'" [style.background-color]="background_color">
  <div class="frame-body">
    <mat-button-toggle-group [(ngModel)]="viewType" aria-label="Font Style">
      <mat-button-toggle value="about">
        <mat-icon>info</mat-icon> Acerca de
      </mat-button-toggle>
      <mat-button-toggle value="map">
        <mat-icon>map</mat-icon> Mapa
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="frame-body" *ngIf="viewType == 'about'">
    <div
      fxLayout="row"
      style="
        width: 100%;
        height: 360px;
        flex-direction: row;
        box-sizing: border-box;
        display: flex;
      "
    >
      <div fxFlex="100" *ngIf="has_nutritional_list">
        <div style="padding: 0.5em 0em">
          <span style="color: #6d008b; font-weight: 700; font-size: 1.8em">
            VALOR NUTRICIONAL <small>* en peso fresco</small>
          </span>
        </div>
        <!-- fila de graficos -->
        <div fxLayout="row" fxLayoutAlign="space-between stretch">
          <div
            style="width: 120px; height: 250px"
            *ngFor="
              let nutritional of inputValuesUsesInformation.nutritional_list;
              let i = index
            "
          >
            <div
              style="
                height: 120px;
                border-top-left-radius: 120px;
                border-top-right-radius: 120px;
              "
              [ngStyle]="{
                'background-color': i % 2 == 0 ? '#ccccd1' : '#e0ddd1'
              }"
            >
              <!-- text top -->
              <div
                style="
                  width: 120px;
                  height: 120px;
                  border: solid 0.5em #fff;
                  border-radius: 50%;
                "
              ></div>
              <div
                style="
                  height: 120px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                  margin-top: -120px;
                "
              >
                <span
                  style="color: #6d008b; font-weight: bold; font-size: 1.1vw"
                >
                  {{ nutritional.text_1 ? nutritional.text_1 : "--" }}
                </span>
              </div>
            </div>

            <div
              style="height: 120px"
              [ngStyle]="{
                'background-color': i % 2 == 0 ? '#ccccd1' : '#e0ddd1'
              }"
            >
              <div
                style="
                  height: 120px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  text-align: center;
                "
              >
                <!-- [style.line-break]="'anywhere'"  -->
                <span
                  style="color: #6d008b; font-weight: bold; font-size: 1.1vw"
                  [ngStyle]="{
                    'line-break': nutritional.text_2.includes('(')
                      ? 'auto'
                      : 'anywhere'
                  }"
                >
                  {{ nutritional.text_2 }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- fila de graficos -->
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxFlex="70" *ngIf="has_culinary_uses">
        <div class="class-frame-4">
          <div class="text-9">
            <span> USOS CULINARIOS </span>
          </div>
          <div class="text-3">
            <span>{{ inputValuesUsesInformation.culinary_uses }}</span>
          </div>

          <div class="text-9">
            <span> Tiempo de coccion: </span>
          </div>
          <div class="text-3">
            <span>{{ inputValuesUsesInformation.cooking_time }}</span>
          </div>
        </div>

        <div class="class-frame-6">
          <div class="text-10">
            <span> INFORMACION ADICIONAL </span>
          </div>

          <div class="text-4">
            <span>
              {{ inputValuesUsesInformation.aditional_information }}
            </span>
          </div>
        </div>
      </div>

      <div fxFlex="30" *ngIf="has_adaptability">
        <div style="margin-bottom: 2em">
          <div class="text-5">
            <span> ADAPTABILIDAD </span>
          </div>
          <div class="text-6">
            <span> m.s.n.m. </span>
          </div>
          <div class="text-7">
            <span>
              {{ inputValuesUsesInformation.adaptability }}
            </span>
          </div>
          <div
            style="height: 340px; margin-top: -113px"
            [style.background]="inputValuesUsesInformation.adaptability_img"
            [style.background-size]="'contain'"
            [style.background-repeat]="'no-repeat'"
            [style.background-position]="'center'"
            [style.background-color]="'#fff'"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <div class="frame-body" *ngIf="viewType == 'map'">
    <app-template-map
      *ngIf="inputValuesUsesInformation.coordinate_list"
      [coordinate_list]="inputValuesUsesInformation.coordinate_list"
      [height_value]="'560px'"
      [title]="'Observado en:'"
      [icon]="'place'"
    ></app-template-map>
  </div>
</div>

<!-- =================================================== -->

<div *ngIf="design == 'row_c'" [style.background-color]="background_color">
  <div class="frame-body" *ngIf="inputTemplate">
    <app-template-a [inputTemplate]="inputTemplate"></app-template-a>
  </div>
</div>
